var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 152,
    viewBox: "0 0 202 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3549 117.462L17.2314 116.155C6.80466 114.849 -0.146567 104.83 1.15678 94.3754L12.4525 17.2744C13.7558 6.81999 23.7481 -0.149603 34.1749 1.15719L177.977 22.066C186.666 23.3728 193.617 30.7779 194.052 39.0543",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.884 151.003H45.4673C35.0405 151.003 26.3516 142.291 26.3516 131.836V54.2997C26.3516 43.8453 35.0405 35.1333 45.4673 35.1333H181.884C192.311 35.1333 201 43.8453 201 54.2997V132.272C201 142.726 192.311 151.003 181.884 151.003Z",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0068 104.827H52.4155C47.6366 104.827 43.7266 100.907 43.7266 96.1151V86.0963C43.7266 81.3047 47.6366 77.3843 52.4155 77.3843H75.0068C79.7857 77.3843 83.6957 81.3047 83.6957 86.0963V96.1151C83.6957 100.907 79.7857 104.827 75.0068 104.827Z",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9245 134.015H48.5055C45.8988 134.015 43.7266 131.837 43.7266 129.223V127.481C43.7266 124.867 45.8988 122.689 48.5055 122.689H68.9245C71.5312 122.689 73.7035 124.867 73.7035 127.481V129.223C73.7035 131.837 71.5312 134.015 68.9245 134.015Z",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.41 62.5786H139.744C137.137 62.5786 134.965 60.4006 134.965 57.787V55.609C134.965 52.9954 137.137 50.8174 139.744 50.8174H178.41C181.016 50.8174 183.189 52.9954 183.189 55.609V57.3514C183.623 60.4006 181.451 62.5786 178.41 62.5786Z",
    fill: "#232935",
    fillOpacity: 0.15
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.417 134.015H84.9977C82.391 134.015 80.2188 131.837 80.2188 129.223V127.481C80.2188 124.867 82.391 122.689 84.9977 122.689H105.417C108.023 122.689 110.196 124.867 110.196 127.481V129.223C110.196 131.837 108.023 134.015 105.417 134.015Z",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.351 134.017H121.498C118.891 134.017 116.719 131.839 116.719 129.225V127.047C116.719 124.433 118.891 122.255 121.498 122.255H142.351C144.958 122.255 147.13 124.433 147.13 127.047V129.225C147.13 131.839 144.958 134.017 142.351 134.017Z",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.409 134.017H158.424C155.818 134.017 153.211 131.839 153.211 128.789V127.483C153.211 124.869 155.383 122.255 158.424 122.255H178.409C181.016 122.255 183.622 124.433 183.622 127.483V128.789C183.622 131.839 181.016 134.017 178.409 134.017Z",
    stroke: "#232935",
    strokeOpacity: 0.15,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCard);
export default __webpack_public_path__ + "static/media/bank-card.92aaced8f449bffef380783163372902.svg";
export { ForwardRef as ReactComponent };